module.exports = __webpack_public_path__ + "img/57.16835d7b.jpg";